/**
 * This is the component for the horizontal bar graph for the ports in the dashboard.
 */

import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  ResponsiveContainer,
} from "recharts";
import useProForma from "store/useProForma";

const colorMap = {
  port_1_range_1: "#7095f0",
  port_2_range_2: "#79d161",
  port_3_range_3: "#ea5919",
  port_4_range_4: "#b5625b",
};

const PortsHorizontalGraph = () => {
  const { phases = {}, controls = {}, cityInfo = {} } = useProForma();
  const [data, setData] = useState([]);
  const [rangeName, setRangeNames] = useState({});

  useEffect(() => {
    if (!phases.phases || !controls) {
      return;
    }
    const innerPhase = phases.phases;
    let arr = [0, 0, 0, 0];
    for (let i = 0; i < innerPhase.length; i++) {
      arr[0] += innerPhase[i].port_less_than_10_kw;
      arr[1] += innerPhase[i].port_10_20_kw;
      arr[2] += innerPhase[i].port_25_kw;
      arr[3] += innerPhase[i].port_180_200_kw;
    }

    let rangeNames = {
      port_1_range_1: "<10 kW",
      port_2_range_2: "10-20 kW",
      port_3_range_3: "40 kW",
      port_4_range_4: "180-200 kW",
    };

    rangeNames.port_1_range_1 = cityInfo.range_1
      ? "r1" + cityInfo.range_1
      : rangeNames.port_1_range_1;
    rangeNames.port_2_range_2 = cityInfo.range_2
      ? "r2" + cityInfo.range_2
      : rangeNames.port_2_range_2;
    rangeNames.port_3_range_3 = cityInfo.range_3
      ? "r3" + cityInfo.range_3
      : rangeNames.port_3_range_3;
    rangeNames.port_4_range_4 = cityInfo.range_4
      ? "r4" + cityInfo.range_4
      : rangeNames.port_4_range_4;

    setRangeNames(rangeNames);
    setData([
      {
        name: "Port Counts",
        [rangeNames.port_1_range_1]: arr[0],
        [rangeNames.port_2_range_2]: arr[1],
        [rangeNames.port_3_range_3]: arr[2],
        [rangeNames.port_4_range_4]: arr[3],
      },
    ]);
  }, [phases, controls]);

  const formatLegendLabel = (value) => {
    if (typeof value !== "string") {
      return value;
    }
    return value.replace(/^r[1-4]\s*/i, "");
  };

  return (
    <div className="w-full recharts-custom-optusa">
      <ResponsiveContainer
        width="100%"
        height={50}>
        <BarChart
          layout="vertical"
          data={data}>
          <XAxis
            hide
            type="number"
          />
          <YAxis
            hide
            dataKey="name"
            type="category"
          />
          <Legend
            align="left"
            formatter={formatLegendLabel}
            wrapperStyle={{ fontSize: "12px" }}
          />

          {Object.entries(rangeName).map(([key, value]) => (
            <Bar
              key={key}
              dataKey={value}
              stackId="a"
              fill={colorMap[key]}
              radius={[5, 5, 5, 5]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PortsHorizontalGraph;
